<div class="holder">
  <div class="contact-info">
    <h1>İletişim</h1>
    <p class="contact-item">
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="contact-icon"
      >
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
        <circle cx="12" cy="10" r="3"></circle>
      </svg>
      <span>
        <strong>Adres:</strong> Fulya Mahallesi, Yeşilçimen Sokak, Polat Tower,
        Bilgiyi Ticarileştirme Merkezi Kampüsü 34394 Şişli/İstanbul
      </span>
    </p>
    <p class="contact-item">
      <img
        src="assets/images/mobile-phone.png"
        alt="phone"
        class="contact-icon"
      />
      <span>
        <strong>Telefon: </strong>
        <a href="tel:+90 850 304 9346">+90 850 304 9346</a>
      </span>
    </p>
    <p class="contact-item">
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="contact-icon"
      >
        <path
          d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
        ></path>
      </svg>
      <span>
        <strong>Mobil: </strong>
        <a href="tel:+90 533 379 2509">+90 533 379 2509</a> (WhatsApp hattı)
      </span>
    </p>
    <p class="contact-item">
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="contact-icon"
      >
        <path
          d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
        ></path>
        <polyline points="22,6 12,13 2,6"></polyline>
      </svg>
      <span>
        <strong>E-Posta: </strong>
        <a href="mailto:info@{{ hostName }}">info&#64;{{ hostName }}</a>
      </span>
    </p>
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3008.5582328362802!2d28.99575027672659!3d41.0567888713438!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab9ec0e422ee9%3A0xe48bbf2454159e09!2sBilgiyi%20Ticarile%C5%9Ftirme%20Merkezi!5e0!3m2!1sen!2str!4v1754914949796!5m2!1sen!2str"
      width="600"
      height="450"
      style="border: 0"
      allowfullscreen=""
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
  <div class="form-holder">
    <form action="/" (submit)="onSubmit($event)">
      <div>
        <label for="">Ad Soyad</label>
        <input type="text" name="name" required />
      </div>
      <div>
        <label for="">Eposta</label>
        <input type="email" name="email" required />
      </div>
      <div>
        <label for="">Telefon Numarası</label>
        <input type="tel" name="tel" />
      </div>
      <div>
        <label for="">Konu</label>
        <input type="text" name="title" required />
      </div>
      <div>
        <label for="">Mesaj</label>
        <textarea name="text" value="" rows="3" required> </textarea>
      </div>
      <button type="submit">Gönder</button>
      <div class="register-agreement">
        Kayıt Ol’a basarak Bilgesin
        <a href="/kullanim-kosullari" target="_blank">Kullanım Koşullarını</a>
        onayladığınız ve KVKK
        <a href="/kisisel-verilerin-korunmasi" target="_blank"
          >Gizlilik ve Çerez Politikasını</a
        >
        okuyup, anladığınızı kabul edersiniz.
      </div>
    </form>
  </div>
</div>
